import AccommodationForm from '../screens/AccommodationForm'
import AccommodationTabs from '../screens/AccommodationTabs'
import AccommodationsList from '../screens/AccommodationsList'
import { RouteWithAccessType } from './types'

const accommodationPagesRoleManagement: RouteWithAccessType[] = [
  {
    route: '/accommodations',
    exact: true,
    requiredFeatures: ['accommodation.list.view'],
    component: <AccommodationsList />,
    sections: {
      ADD_ACCOMMODATION: {
        requiredFeatures: ['accommodation.create']
      },
      SELECT_ACCOMMODATION: {
        requiredFeatures: ['accommodation.details.view']
      },
      IMPORT_DATA: {
        requiredFeatures: ['accommodation.pms.trigger']
      }
    }
  },
  {
    route: '/accommodations/create',
    exact: true,
    requiredFeatures: ['accommodation.create'],
    component: <AccommodationForm />
  },
  {
    route: '/accommodations/:accID/:propertyCode/:page',
    exact: true,
    requiredFeatures: ['accommodation.list.view'],
    component: <AccommodationTabs />,
    tabs: [
      {
        params: { page: 'details' },
        requiredFeatures: ['accommodation.details.view'],
        sections: {
          EDIT_ACCOMMODATION: {
            requiredFeatures: ['accommodation.details.edit']
          }
        }
      },
      {
        params: { page: 'logo' },
        requiredFeatures: ['accommodation.logo.manage']
      },
      {
        params: { page: 'images' },
        requiredFeatures: ['accommodation.images.manage']
      },
      {
        params: { page: 'cover' },
        requiredFeatures: ['accommodation.cover.manage']
      },
      {
        params: { page: 'facilities' },
        requiredFeatures: ['accommodation.facilities.manage']
      },
      {
        params: { page: 'pms-mapping' },
        requiredFeatures: ['accommodation.pms.mapping.manage']
      },
      {
        params: { page: 'associated-gateways' },
        requiredFeatures: ['accommodation.associated.gateways.manage']
      },
      {
        params: { page: 'booking-permission' },
        requiredFeatures: ['accommodation.booking.permission']
      },
      {
        params: { page: 'provider-submit' },
        requiredFeatures: ['accommodation.provider.submit.manage']
      }
    ]
  }
]

export default accommodationPagesRoleManagement
